import { Box } from '@mui/material';
import ProfileDetailsCard from './ProfileDetailsCard';
import ProfileSubscriptionPanel from './ProfileSubscriptionPanel';
import RapCardShield from './RapCardShield';

/** Figma 11059:1205 — desktop My Profile layout */
export default function ProfileDesktopView({ profile }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: { xs: '10px', lg: '78px', xl: '96px' },
        width: '100%',
        maxWidth: 1120,
        mx: 'auto',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '38px', width: '100%', maxWidth: 400, mx: 'auto' }}>
        <ProfileDetailsCard profile={profile} />
        <ProfileSubscriptionPanel profile={profile} />
      </Box>

      <RapCardShield profile={profile} />
    </Box>
  );
}
